module.exports = __webpack_public_path__ + "6a05b9afd8880f0095ff7bcffa95950b.MP3";